import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';
import { createUseStyles } from 'react-jss';
import { EnrollmentStage } from 'types/enrollmentService';

const styles: ComponentStylesProps<EnrollmentStage> = {
  tag: {
    font: {
      size: '1.2rem',
      lineHeight: '2.4rem',
      weight: 400,
    },
    textAlign: 'center',
    color: colors.neutral[900],
    width: '8.8rem',
    verticalAlign: 'middle',
    borderRadius: '14px',
  },
  tagTypeNotYetDefined: { backgroundColor: colors.neutral[300] },
  tagTypeInvited: { backgroundColor: colors.purple[400] },
  tagTypeLead: { backgroundColor: colors.green[300] },
  tagTypeActive: { backgroundColor: colors.red[200] },
  tagTypeQuoting: { backgroundColor: colors.purple[300] },
  tagTypeEnrollment: { backgroundColor: colors.yellow[200] },
  tagTypeSubmitted: { backgroundColor: colors.blue[300] },
  tagTypeRenewal: { backgroundColor: colors.orange[300] },
  tagTypeInstalled: { backgroundColor: colors.indigo[600], color: colors.neutral.white },
  tagTypeArchived: { backgroundColor: colors.neutral[400], color: colors.neutral.white },
  tagTypeSold: { backgroundColor: colors.green[700], color: colors.neutral.white },
  tagTypeDormant: { backgroundColor: colors.red[700], color: colors.neutral.white },
};

const createStyles = createUseStyles(styles);

export { createStyles };
